import React, { FC } from "react";
import { Avatar, Badge } from "antd";
import { Colors } from "../../colors";

export type NotificationBadgeProps = {
  count: number;
  onBellClick: () => void;
};

export const NotificationBadge: FC<NotificationBadgeProps & { icon: React.ReactNode }> = ({
  count,
  icon,
  onBellClick,
}) => {
  return (
    <a onClick={() => onBellClick()}>
      <Badge size="small" count={count} overflowCount={10}>
        <Avatar style={{ backgroundColor: Colors.Primary }} icon={icon} />
      </Badge>
    </a>
  );
};
